import { motion } from 'motion/react'
import { Shield, Brain, Sparkles } from 'lucide-react'
import './TeachKids.css'

const benefits = [
  {
    icon: Shield,
    title: 'Recognize Threats',
    description:
      'Learn to spot catfishing, grooming, scams, and other online dangers early',
    cardClass: 'tk__card--1'
  },
  {
    icon: Brain,
    title: 'Make Smart Choices',
    description:
      "Practice making safe decisions through interactive scenarios — so they're prepared when it matters most",
    cardClass: 'tk__card--2'
  },
  {
    icon: Sparkles,
    title: 'Build Confidence',
    description:
      'Gain the knowledge and confidence to explore the digital world safely and responsibly',
    cardClass: 'tk__card--3'
  }
]

const TeachKids = () => {
  return (
    <section className='tk'>
      <div className='tk__inner'>
        <motion.div
          className='tk__header'
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            className='tk__badge'
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <Shield size={16} aria-hidden='true' />
            <span className='tk__badge-text'>ONLINE SAFETY EDUCATION</span>
          </motion.div>

          <h2 className='tk__title'>
            We Teach Kids How to
            <br />
            <span className='tk__title-highlight'>Stay Safe Online</span>
          </h2>

          <p className='tk__subtitle tk__subtitle--desktop'>
            We focus on two critical abilities: recognizing danger online early
            and knowing how to respond safely when threats appear.
          </p>
          <p className='tk__subtitle tk__subtitle--mobile'>
            We focus on two critical abilities: recognizing danger online early
            and knowing how to respond safely.
          </p>
        </motion.div>

        <div className='tk__grid'>
          {benefits.map((item, index) => {
            const Icon = item.icon
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 + index * 0.1 }}
                className='tk__card-wrap'
              >
                <div className={`tk__card ${item.cardClass}`}>
                  <div className='tk__card-pattern' aria-hidden='true' />
                  <div className='tk__card-icon-wrap'>
                    <Icon size={32} aria-hidden='true' />
                  </div>
                  <h3 className='tk__card-title'>{item.title}</h3>
                  <p className='tk__card-desc'>{item.description}</p>
                </div>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default TeachKids
